export default function (nga, admin, menu) {
    var _ename = 'ftp';
    var _epretty = 'Ftp';
    var _entity = nga.entity(_ename);
    
    
    _entity.listView()
        .title(_epretty)
        .description("ATENÇÃO: Antes de apagar um utilizador deve-se limpar os dados que foram carregados para a pasta. Durante a criação é necessário esperar cerca de 1 minuto até ser possivel connectar por ftp.")
        .fields([
            nga.field('id').label('ID'),
            nga.field('name').label('Name').isDetailLink(true),
        
        ])
        .sortField('name')
        .sortDir('asc')
        .listActions(['edit']);

        
    _entity.editionView()
        .title('Edit ' + _epretty)
        .fields([,
            nga.field('password')
                    .label('Password')
                    .validation({ required: true, minlength: 6 })
                    .isDetailLink(true)
        ]);
        
    _entity.creationView()
        .title('Create new ' + _epretty)
        .fields([,
            nga.field('name')
                    .label('Name')
                    .validation({ required: true, pattern: '[A-Za-z0-9]{5,20}' })
                    .isDetailLink(true),
            nga.field('password')
                    .label('Password')
                    .validation({ required: true, minlength: 6  })
                    .isDetailLink(true)
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/ftp.js